import { Directive, HostListener, Input, Optional } from '@angular/core';

import { AccordionComponent } from '@app/shared/modules/accordion/components/accordion.component';

@Directive({ standalone: false, selector: '[adsptAccordionToggle]' })
export class AccordionToggleDirective {
  @HostListener('click', ['$event'])
  onClick(event: UIEvent): void {
    event.stopPropagation();
    this.accordion?.toggle();
  }

  @Input()
  outsideAccordion?: AccordionComponent;

  get accordion(): AccordionComponent | undefined {
    return this.outsideAccordion || this.parentAccordion;
  }

  constructor(@Optional() private parentAccordion?: AccordionComponent) {}
}
